import { Networks } from "impermax-sdk";
import React from "react";
import { InteractionModalContainer } from ".";
import { useNetworkName } from "../../hooks/useNetwork";

export interface AccountModalProps {
  show: boolean;
  toggleShow(s: boolean): void;
}

export default function NetworkSelectorModal({show, toggleShow}: AccountModalProps) {
  const networkName = useNetworkName();

  return (
    <InteractionModalContainer title="Select a Network" show={show} toggleShow={toggleShow}><>
      <ul className="network-selector-list">
        <li className={ networkName === Networks.Mainnet ? "selected" : "" }>
          <a href={ networkName === Networks.Mainnet ? "javascript:void()" : "https://app.impermax.finance"}>
            <div className="network-logo ethereum"><img src={"../../assets/networks-white/ethereum.png"} /></div> 
            Ethereum
           </a>
        </li>
        <li className={ networkName === Networks.Base ? "selected" : "" }>
          <a href={ networkName === Networks.Base ? "javascript:void()" : "https://base.impermax.finance"}>
            <div className="network-logo base"><img src={"../../assets/networks-white/base.png"} /></div> 
            Base
          </a>
        </li>
        <li className={ networkName === Networks.Arbitrum ? "selected" : "" }>
          <a href={ networkName === Networks.Arbitrum ? "javascript:void()" : "https://arbitrum.impermax.finance"}>
            <div className="network-logo arbitrum"><img src={"../../assets/networks-white/arbitrum.png"} /></div> 
            Arbitrum
          </a>
        </li>
        <li className={ networkName === Networks.Optimism ? "selected" : "" }>
          <a href={ networkName === Networks.Optimism ? "javascript:void()" : "https://optimism.impermax.finance"}>
            <div className="network-logo optimism" style={{backgroundImage: "url('../../assets/networks-white/optimism.png')"}} />
            Optimism
          </a>
        </li>
        <li className={ networkName === Networks.Scroll ? "selected" : "" }>
          <a href={ networkName === Networks.Scroll ? "javascript:void()" : "https://scroll.impermax.finance"}>
            <div className="network-logo scroll"><img src={"../../assets/networks-white/scroll.png"} /></div>
            Scroll
          </a>
        </li>
        <li className={ networkName === Networks.Blast ? "selected" : "" }>
          <a href={ networkName === Networks.Blast ? "javascript:void()" : "https://blast.impermax.finance"}>
            <div className="network-logo blast"><img src={"../../assets/networks-white/blast.png"} /></div> 
            Blast
          </a>
        </li>
        <li className={ networkName === Networks.ZksyncEra ? "selected" : "" }>
          <a href={ networkName === Networks.ZksyncEra ? "javascript:void()" : "https://zksync-era.impermax.finance"}>
            <div className="network-logo zksync-era"><img src={"../../assets/networks-white/zksync-era.png"} /></div> 
            ZkSync Era
          </a>
        </li>
        <li className={ networkName === Networks.Polygon ? "selected" : "" }>
          <a href={ networkName === Networks.Polygon ? "javascript:void()" : "https://polygon.impermax.finance"}>
            <div className="network-logo polygon"><img src={"../../assets/networks-white/polygon.png"} /></div> 
            Polygon (Matic)
          </a>
        </li>
        <li className={ networkName === Networks.Fantom ? "selected" : "" }>
          <a href={ networkName === Networks.Fantom ? "javascript:void()" : "https://fantom.impermax.finance"}>
            <div className="network-logo fantom"><img src={"../../assets/networks-white/fantom.png"} /></div> 
            Fantom
          </a>
        </li>
        <li className={ networkName === Networks.Sonic ? "selected" : "" }>
          <a href={ networkName === Networks.Sonic ? "javascript:void()" : "https://sonic.impermax.finance"}>
            <div className="network-logo sonic"><img src={"../../assets/networks-white/sonic.png"} /></div> 
            Sonic
          </a>
        </li>
        <li className={ networkName === Networks.Linea ? "selected" : "" }>
          <a href={ networkName === Networks.Linea ? "javascript:void()" : "https://linea.impermax.finance"}>
            <div className="network-logo linea"><img src={"../../assets/networks-white/linea.png"} /></div> 
            Linea
          </a>
        </li>
        <li className={ networkName === Networks.Avalanche ? "selected" : "" }>
          <a href={ networkName === Networks.Avalanche ? "javascript:void()" : "https://avalanche.impermax.finance"}>
            <div className="network-logo avalanche"><img src={"../../assets/networks-white/avalanche.png"} /></div> 
            Avalanche
          </a>
        </li>
        <li className={ networkName === Networks.Real ? "selected" : "" }>
          <a href={ networkName === Networks.Real ? "javascript:void()" : "https://real.impermax.finance"}>
            <div className="network-logo real"><img src={"../../assets/networks-white/real.png"} /></div>
            re.al
          </a>
        </li>
        {/* <li className={ networkName === Networks.Moonriver ? "selected" : "" }>
          <a href={ networkName === Networks.Moonriver ? "javascript:void()" : "https://moonriver.impermax.finance"}>
            <div className="network-logo moonriver"><img src={"../../assets/networks-white/moonriver.png"} /></div> 
            Moonriver
          </a>
        </li>
        <li className={ networkName === Networks.Canto ? "selected" : "" }>
          <a href={ networkName === Networks.Canto ? "javascript:void()" : "https://canto.impermax.finance"}>
            <div className="network-logo canto"><img src={"../../assets/networks-white/canto.png"} /></div> 
            Canto
          </a>
        </li> 
        <li className={ networkName === Networks.Mantle ? "selected" : "" }>
          <a href={ networkName === Networks.Mantle ? "javascript:void()" : "https://mantle.impermax.finance"}>
            <div className="network-logo mantle"><img src={"../../assets/networks-white/mantle.png"} /></div> 
            Mantle
          </a>
        </li> */}
      </ul>
    </></InteractionModalContainer>
  );
}